module.exports = __webpack_public_path__ + "img/googleid.7ba0c449.svg";